<rt-infobox iconName="info-outline" [isDismissible]="false">
  {{ 'app.onboarding.sample_data_infobox.text_1' | translate }}
  <a (click)="onRemoveSampleData()" class="link">{{
    'app.onboarding.sample_data_infobox.text_2' | translate
  }}</a
  >.
</rt-infobox>
